// src/redux/api/public/coingecko.ts

import { publicApi } from './index';

// Types for the CoinGecko OHLCV API
export interface OHLCVData {
  unixTime: number;
  value: number;
  open: number;
  high: number;
  low: number;
  volume: number;
}

export interface OHLCVResponse {
  data: {
    id: string;
    type: string;
    attributes: {
      ohlcv_list: Array<[number, number, number, number, number, number]>; // [timestamp, open, high, low, close, volume]
    };
  };
}

export interface GetOHLCVParams {
  network: string;
  tokenAddress: string;
  timeframe: string;
  aggregate: number;
  limit: number;
  currency?: string;
}

export const publicCoingeckoApi = publicApi.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Query to get OHLCV (Open, High, Low, Close, Volume) data for a token.
     * Sends a GET request to /api/coingecko/onchain/networks/{network}/tokens/{tokenAddress}/ohlcv/{timeframe}
     * Returns OHLCV data via backend proxy to CoinGecko API.
     */
    getTokenOHLCV: builder.query<OHLCVResponse, GetOHLCVParams>({
      query: ({
        network,
        tokenAddress,
        timeframe,
        aggregate,
        limit,
        currency = 'usd',
      }) => ({
        url: `/coingecko/onchain/networks/${network}/tokens/${tokenAddress}/ohlcv/${timeframe}`,
        params: {
          aggregate,
          limit,
          currency,
        },
      }),
    }),
  }),
  overrideExisting: true,
});

// Export hooks for usage in functional components
export const { useGetTokenOHLCVQuery, useLazyGetTokenOHLCVQuery } =
  publicCoingeckoApi;
